<div class="row" id="listView">
  @if (data.data.length <= 0) {
  <div class="col-12">
    <div class="alert alert-primary bergh-text-primary text-center">
      Geen data gevonden
    </div>
  </div>
  } @if (data.data.length > 0) {
  <div class="col-12">
    <table class="table border bg-white">
      @if (!data.suppressHeader) {
      <thead>
        <tr>
          @for (header of data.headers; track header) {
          <th scope="col">{{ header.title }}</th>
          } @if (data.primaryButtonGroup.length > 0 ||
          data.secondaryButtonGroup.length > 0) {
          <th class="last-th">Acties</th>
          }
        </tr>
      </thead>
      }
      <tbody>
        @for (row of data.data; track row; let i = $index) {
        <tr>
          @for (col of data.headers; track col; let p = $index) {
          <td id="cell-{{ i }}-{{ p }}" [ngClass]="setStyle(col, row[col.key])">
            {{ row[col.key] }}
          </td>
          } @if (data.primaryButtonGroup.length > 0 ||
          data.secondaryButtonGroup.length > 0) {
          <td>
            <div class="d-flex">
              @for (pBtn of data.primaryButtonGroup; track pBtn; let j = $index)
              {
              <button
                class="btn bergh-btn-secondary text-white {{
                  pBtn.class ? pBtn.class : ''
                }}"
                title="{{ pBtn.title }}"
                (click)="primaryButtonResponse.emit({ _id: row._id, btn: j, action: pBtn.action })"
                id="primaryBtn-{{ i }}-{{ j }}"
              >
                <i-feather
                  name="{{ pBtn.icon }}"
                  class="small-icon"
                ></i-feather>
              </button>
              } @for (sBtn of data.secondaryButtonGroup; track sBtn; let k =
              $index) {
              <button
                class="btn btn-secondary {{ sBtn.class ? sBtn.class : '' }}"
                title="{{ sBtn.title }}"
                (click)="secondaryButtonResponse.emit({ _id: row._id, btn: k, action: sBtn.action })"
                id="secondaryBtn-{{ i }}-{{ k }}"
              >
                <i-feather
                  name="{{ sBtn.icon }}"
                  class="small-icon"
                ></i-feather>
              </button>
              }
            </div>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
